import React from "react";
import "./Captcha.scss";
import Turnstile, { useTurnstile } from "react-turnstile";

export default function Captcha({
  sitekey = "0x4AAAAAABC6x_zBJGBeMduh",
  onError = () => null,
  onVerify = () => null,
}) {
  const turnstile = useTurnstile();
  function onExpired() {
    turnstile.reset();
  }

  return (
    <div className="captcha">
      <Turnstile
        sitekey={sitekey}
        // onError={MessageServices.ShowError(
        //   "Ocorreu um erro na validação do CAPTCHA. Por favor, entre em contato com o suporte.",
        // )}
        // onExpired={onExpired}
        onVerify={(token) => {
          onVerify(token);
        }}
      />
    </div>
  );
}
